import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import { Grid } from "@mui/material";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import getMachines from "../../../../../API/machines";
import getTerminals from "../../../../../API/terminals";
import Button from "../../../../../Component/Button/Button";
import classes from "./TaskmapWizard.module.css";
import { TaskmapProduct } from "../../../../../API/taskmap";
import { MachineSelector } from "./MachineSelector";
import { TerminalSelector } from "./TerminalSelector";

export type TaskmapWizardProps = {
  product: TaskmapProduct;
  setMachine: (machine: string) => void;
  children: React.ReactNode;
  setTerminal: (machine: string) => void;
};

export default function TaskmapWizard({
  setMachine,
  setTerminal,
  children,
  product,
}: TaskmapWizardProps): React.ReactNode {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const stepContent = [
    <Grid data-id="first-step" container key={0}>
      <Grid size={{ xs: 12, md: 8, lg: 6 }}>
        <MachineSelector
          machines={getMachines(product)}
          setMachine={setMachine}
        />
        <TerminalSelector
          terminals={getTerminals(product)}
          setTerminal={setTerminal}
        />

        <Button variant="contained" fullWidth onClick={handleNext}>
          {t("button.taskmap.continue")}
        </Button>
      </Grid>
    </Grid>,
    <Grid container key={1} alignItems="center">
      {children}
    </Grid>,
  ];

  return (
    <div className={` ${classes.taskmapWidget}`}>
      <h1>{t("heading.Taskmap")}</h1>
      <HorizontalLinearStepper
        stepContent={stepContent}
        activeStep={activeStep}
        product={product}
      />
    </div>
  );
}

export function HorizontalLinearStepper({
  stepContent,
  activeStep,
  product,
}: {
  stepContent: React.ReactNode[];
  activeStep: number;
  product: TaskmapProduct;
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep}>
        <Step>
          <StepLabel>
            {product === TaskmapProduct.VIGOUR
              ? t("taskmap.wizard.step1.label")
              : t("label.Select Machine")}
          </StepLabel>
        </Step>
        <Step>
          <StepLabel>{t("label.Select thresholds")}</StepLabel>
        </Step>
      </Stepper>
      <Box>{stepContent[activeStep]}</Box>
    </Box>
  );
}
